import { render, staticRenderFns } from "./GTextEditor.vue?vue&type=template&id=7bb92dca&scoped=true&"
import script from "./GTextEditor.vue?vue&type=script&lang=js&"
export * from "./GTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./GTextEditor.vue?vue&type=style&index=0&id=7bb92dca&scoped=true&lang=css&"
import style1 from "./GTextEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb92dca",
  null
  
)

export default component.exports